export enum PlanTabs {
  AWAY = 'Uzaktan Çalışma',
  OFFICE = 'Şirketimin Ofisleri',
  COMMON = 'Ortak Ofisler',
}

/* export enum CampusPlanTabs {
  HEALTH = 'Sağlık Hizmetleri',
  GYM = 'Spor Salonları',
  COIFFEUR = 'Kuaför Hizmetleri',
  LACTATION = 'Süt Odası Hizmetleri',
} */
